import { render, staticRenderFns } from "./CumulativeFeed.vue?vue&type=template&id=202eb922&"
import script from "./CumulativeFeed.vue?vue&type=script&lang=js&"
export * from "./CumulativeFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports